import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CenterDepartment } from 'src/app/shared/models/center-department';

@Component({
	selector: 'app-center-department-form',
	templateUrl: './center-department-form.component.html',
	styleUrl: './center-department-form.component.scss'
})
export class CenterDepartmentFormComponent {
	@Input() centerDepartment: CenterDepartment;
	@Input() isAddForm: boolean;
	@Input() form: FormGroup;
	@Output() sendForm: EventEmitter<any> = new EventEmitter();
	@Output() hideModal: EventEmitter<any> = new EventEmitter();
	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	@Input() isValidateButtonClicked: { value: boolean };

	MAX_NAME_CHAR = 25;

	constructor() {}

	onSubmit(): void {
		if (this.form.valid) {
			this.isValidateButtonClicked.value = true;
			this.centerDepartment.name = this.form.get('name').value;
			this.centerDepartment.description = this.form.get('description').value;
			this.sendForm.emit();
		} else {
			this.isValidateButtonClicked.value = false;
		}
	}

	get name() {
		return this.form?.get('name');
	}
	get description() {
		return this.form?.get('description');
	}
}
